// apps/client/src/client/services/user/user-stats.ts

import { useQuery } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import qs from "qs";

export interface UserStats {
  total: number;
  newUsers: number;
  active: number;
  banned: number;
  verificationRate: number;
  verified: number;
}

export const fetchUserStats = async (from?: Date, to?: Date): Promise<UserStats> => {
  const params = { from: from?.toISOString(), to: to?.toISOString() };
  const response = await axios.get<UserStats>("/analytics/user/stats", {
    params,
    paramsSerializer: (p) => qs.stringify(p, { skipNulls: true }),
  });
  return response.data;
};

export const useUserStats = (from?: Date, to?: Date) => {
  return useQuery({
    queryKey: ["userStats", from, to],
    queryFn: () => fetchUserStats(from, to),
    // Optionnel : on peut désactiver si from/to non définis
    enabled: true,
  });
};
